//物料配置--编辑
import React, { Component } from "react";
import { Form, Select, Radio, Spin, Input, Button, message, Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import RichEditor from "@/components/display/richEditor";
import { updateStatusCodeInfo, getMaterialsUseList, updateMaterialsType } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import "@/assets/stylus/addDownloadPage.styl";

const FormItem = Form.Item;
const { Option } = Select;
const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

class TMaterialsTypeConfig extends Component {
  constructor(props) {
    super(props);

    const levelOption = window.LayoutTab.tabParam.levelOption;
    this.props = props;
    this.state = {
      btnClicked: true, // 提交按钮是否可点 ： true：不可点，false:可点
      record: window.LayoutTab.tabParam.errorCodeInfo || {},
      levelOption: levelOption ? levelOption.filter((v) => v.value !== "") : [],
      reasonOption: [],
      triggerOption: [],
      defaultLvItem: levelOption.find((v) => v.text === "重大"),
      loading: false,
    };
  }

  // 设置Form的ref
  formRef = React.createRef();

  // 获取用途列表
  getTriggerOption = () => {
    fetchHandler(getMaterialsUseList, {
      code: "maint.statustigger",
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          triggerOption: res.data,
        });
      }
    });
  };

  // 取消操作
  handleCancel = async () => {
    await this.props.onDelete("tMaterialsTypeConfig");
    this.props.onAdd({
      key: "9014",
      titleText: "物料配置",
    });
  };
  /**
   * 点击提交按钮执行方法
   */

  submitForm = () => {
    // 检查 五个字段是否为空，并且三个金额字段是数值类型
    const info = this.formRef.current.getFieldsValue();
    const number = /^(\-|\+)?\d+(\.\d+)?$/;
    if (info.newPrice == "" && info.newPrice !== 0) {
      message.error("请填写新件价格");
      return;
    }
    if (
      // !info.newPrice || info.newPrice == "" ||
      !number.test(info.newPrice)
    ) {
      message.error("新件价格必须填写数值类型");
      return;
    }
    if (
      // !info.oldPrice || info.oldPrice == "" ||
      !number.test(info.oldPrice)
    ) {
      message.error("旧件价格必须填写数值类型");
      return;
    }
    if (
      // !info.cost || info.cost == "" ||
      !number.test(info.cost)
    ) {
      message.error("成本价格必须填写数值类型");
      return;
    }
    if ((!info.brand && info.brand === null) || info.brand === "") {
      message.error("请填写品牌");
      return;
    }
    // if ((!info.description && info.description == null) || info.description == "") {
    //   message.error("请填写备注信息");
    //   return;
    // }
    this.setState({
      loading: true,
    });

    info.materialsId = this.state.record.key;
    console.log("info:", info);
    fetchHandler(updateMaterialsType, info).then((res) => {
      this.setState({
        loading: false,
      });
      if (res && res.code === "success") {
        message.success("配置成功！");
        this.handleCancel();
      }
    });
  };

  componentWillMount() {
    const { record } = this.state;
    this.getTriggerOption();
    this.setState({
      isAlert: !record.isAlert || record.isAlert === "--" ? 0 : record.isAlert,
    });
  }

  // 空字符
  // requiredExcludesNullStr = (rule, value) => {
  //     if (value || value === '') {
  //         return Promise.resolve();
  //     }
  //     return Promise.reject();
  // }
  render() {
    const { record, levelOption, reasonOption, triggerOption, isAlert } = this.state;

    const Content = (
      <Spin spinning={this.state.loading}>
        <div
          className="download-task-build-content error-code-config-container"
          style={{ width: "650px", padding: "24px" }}>
          <Form {...layout} ref={this.formRef}>
            {/* 指标类型 */}
            <div className="formTit">基础定义</div>
            <div className="indicatorType">
              <FormItem label="物料编号" name="materialsCode" initialValue={record.materialsCode}>
                <Input disabled placeholder="物料编号" />
              </FormItem>
              <FormItem label="物料名称" name="materialsName" initialValue={record.materialsName}>
                <Input
                  // disabled
                  placeholder="物料名称"
                />
              </FormItem>
              <FormItem label="规格型号" name="regularModel" initialValue={record.regularModel}>
                <Input
                  // disabled
                  placeholder="规格型号"
                />
              </FormItem>
              <FormItem label="单位" name="unit" initialValue={record.unit}>
                <Input
                  //  disabled
                  placeholder="单位"
                />
              </FormItem>
              <FormItem
                label="新件价格"
                name="newPrice"
                initialValue={record.newPrice}
                rules={[
                  {
                    required: true,
                    message: "新件价格不能为空",
                  },
                ]}>
                <Input placeholder="新件价格" />
              </FormItem>
              <FormItem label="旧件价格" name="oldPrice" initialValue={record.oldPrice}>
                <Input placeholder="旧件价格" />
              </FormItem>
              <FormItem label="成本" name="cost" initialValue={record.cost}>
                <Input placeholder="成本" />
              </FormItem>

              <FormItem
                label="用途"
                name="userTypeId"
                initialValue={!record.userTypeId ? null : record.userTypeId}>
                <Select onChange={this.changeDataDimention}>
                  {triggerOption.map((v) => (
                    <Option value={v.id}>{v.name}</Option>
                  ))}
                </Select>
              </FormItem>

              <FormItem label="品牌" name="brand" initialValue={record.brand}>
                <Input />
              </FormItem>

              <FormItem label="处置方式" name="handingType" initialValue={`${record.handingType}`}>
                <Select>
                  <Option value="2">维修利用</Option>
                  <Option value="0">其他</Option>
                </Select>
              </FormItem>

              <FormItem
                label="备注"
                name="description"
                initialValue={
                  !record.description || record.description === "--" ? null : record.description
                }>
                <Input.TextArea placeholder="备注" />
              </FormItem>
            </div>
          </Form>
          <div className="submitBtns">
            <Button onClick={this.submitForm} type="primary">
              确定
            </Button>
            <Button onClick={this.handleCancel}> 取消 </Button>
          </div>
        </div>
      </Spin>
    );

    return Content;
  }
}

export default TMaterialsTypeConfig;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/tMaterialsTypeManage/tMaterialsTypeConfig.js